export default __webpack_public_path__ + "static/media/PermanentMarker-Regular.109a10dc.ttf";